module.exports = __webpack_public_path__ + "img/keder_himmelblau_ral5015.b50b0a85.jpg";